import { rebottle } from "../elements";
import type { BottleType, CanvasData } from "../schema";
import { INK, centred, doc, hairline, imageSlot } from "./kit";
import type { LabelTemplate } from "./types";

// Logo only: the visitor's logo large and centred, a bronze rule and the year.
function wine(): CanvasData {
  const b = "wine";
  return doc(b, INK["warm-white"], [
    imageSlot({ x: 17, y: 24, width: 56, height: 36 }, "Add your logo"),
    hairline(INK.bronze, 45, 70, 24),
    centred(b, { text: "2026", font: "montserrat", size: 2, color: INK.charcoal, baseline: 78, tracking: 0.3 }),
  ]);
}

export const logoOnly: LabelTemplate = {
  key: "logo-only",
  name: "Logo only",
  occasion: "corporate",
  style: "Your logo and a date",
  description: "Your logo, large and centred, with a rule and the year.",
  hasImageSlot: true,
  slot: "logo",
  build: (bottle: BottleType) => (bottle === "wine" ? wine() : rebottle(wine(), bottle)),
};
